export const buildUpdatePayload = (values, data, id) => {
  const discountCodes =
    typeof values?.pro_discount_codes === 'string'
      ? values.pro_discount_codes
          .trim()
          .split(',')
          .map(i => i.trim())
          .filter(i => i.length > 0)
      : Array.isArray(values?.pro_discount_codes)
      ? values.pro_discount_codes
      : [];

  return {
    id,
    settings: {
      ...data?.settings?.dynamic,
      clientData: {
        ...data?.settings?.dynamic?.clientData,
        customization_settings: values.customization_settings,
        pro_discount_codes: discountCodes,
      },
    },
    displayName: data?.displayName,
    storefrontIds:
      data?.settings?.dynamic?.quiversData?.marketplaces?.map(i => i?.marketplace_id)?.filter(n => n) || [],
  };
};

export const getInitialFormValues = (initialValues, data) => {
  const savedCustomizationSettings =
    data?.settings?.dynamic?.clientData?.clientData?.customization_settings ||
    data?.settings?.dynamic?.clientData?.clientdata?.customization_settings ||
    data?.settings?.dynamic?.clientData?.customization_settings ||
    {};

  return {
    ...initialValues,
    customization_settings: initialValues?.customization_settings || savedCustomizationSettings || {},
    pro_discount_codes: (() => {
      const codes = initialValues?.pro_discount_codes || data?.settings?.dynamic?.clientData?.pro_discount_codes;
      return Array.isArray(codes) ? codes.join(', ') : codes || '';
    })(),
  };
};

export const getValidCustomizations = apiCustomizations =>
  Object.entries(apiCustomizations || {}).filter(
    ([label, config]) => label !== 'customizer_name' && typeof config === 'object' && config !== null,
  );

export const syncCustomizationSchema = (apiCustomizations, currentSettings) => {
  let hasChanges = false;
  const newSettings = JSON.parse(JSON.stringify(currentSettings || {}));

  Object.entries(apiCustomizations).forEach(([label, config]) => {
    if (label === 'customizer_name' || typeof config !== 'object' || config === null) return;
    const configKey = config.key;

    if (!newSettings[configKey]) {
      newSettings[configKey] = { enabled: false };
      hasChanges = true;
    } else if (newSettings[configKey].enabled === undefined) {
      newSettings[configKey].enabled = false;
      hasChanges = true;
    }

    if (config.sub_customizations) {
      if (!newSettings[configKey].sub_customizations) {
        newSettings[configKey].sub_customizations = {};
      }
      Object.entries(config.sub_customizations).forEach(([subLabel, subConfig]) => {
        const subKey = subConfig.key;
        if (newSettings[configKey].sub_customizations[subKey] === undefined) {
          newSettings[configKey].sub_customizations[subKey] = false;
          hasChanges = true;
        }
      });
    }
  });

  return { hasChanges, newSettings };
};

export const formatLabel = str => {
  if (!str) return '';
  return str
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

// Adjusts the active stepper index when the Customisation step is shown/hidden.
export const getStepForCustomisation = (currentStep, showCustomisation) => {
  if (!showCustomisation && currentStep === 4) return 3;
  if (!showCustomisation && currentStep === 5) return 4;
  if (showCustomisation && currentStep === 4) return 5;
  return currentStep;
};
